import { useState, useCallback } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import { isNil } from 'lodash';

var createUseGetById = function () {
    return function (adapter, reducerName, idSelector) {
        var _a, _b;
        var id = useSelector(idSelector);
        var rawEntities = useSelector(adapter.getSelectors(function (state) {
            return state[reducerName];
        }).selectEntities);
        var entities = Object.fromEntries((_b = (_a = Object.entries(rawEntities !== null && rawEntities !== void 0 ? rawEntities : {})) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
            var key = _a[0],
                val = _a[1];
            return [String(key), val];
        })) !== null && _b !== void 0 ? _b : []);
        return !isNil(id) ? entities[id] : null;
    };
};
var createAppUseGetByIds = function () {
    return function (adapter, reducerName, idsSelector) {
        var _a, _b;
        var ids = useSelector(idsSelector);
        var rawEntities = useSelector(adapter.getSelectors(function (state) {
            return state[reducerName];
        }).selectEntities);
        var entities = Object.fromEntries((_b = (_a = Object.entries(rawEntities !== null && rawEntities !== void 0 ? rawEntities : {})) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
            var key = _a[0],
                val = _a[1];
            return [String(key), val];
        })) !== null && _b !== void 0 ? _b : []);
        return (ids === null || ids === void 0 ? void 0 : ids.length) > 0 ? ids.map(function (id) {
            return entities[id];
        }) : [];
    };
};
var useEntityThunk = function (thunk, errorMsg, successHandler, errorHandler) {
    var dispatch = useDispatch();
    var _a = useState(''),
        error = _a[0],
        setError = _a[1];
    var _b = useState(false),
        loading = _b[0],
        setLoading = _b[1];
    var _c = useState(),
        response = _c[0],
        setResponse = _c[1];
    var performAction = useCallback(function (payload) {
        setError('');
        setLoading(true);
        return dispatch(thunk(payload)).then(unwrapResult).then(function (response) {
            setLoading(false);
            if (successHandler) {
                successHandler(response);
            }
            setResponse(response);
        }).catch(function (error) {
            if (errorHandler) {
                errorHandler(error);
            }
            setLoading(false);
            setError(errorMsg !== null && errorMsg !== void 0 ? errorMsg : error.message);
            throw error;
        });
    }, [dispatch, thunk, errorMsg, errorHandler, successHandler]);
    return [performAction, loading, error, response];
};

export { createAppUseGetByIds as a, createUseGetById as c, useEntityThunk as u };
